// For display undefined value of user balance
export const USER_BALANCE_UNDEFINED = '*****'
